import React from "react";
import { notification } from "antd";
import { userKcService } from "./../services/UserKcService";
import { UserDoctorDto } from "./../models/UserDoctorDto";
import { useLoaderProvider } from "../contexts/LoaderContext";
import UserProfileForm from "../components/user-profile/UserProfileForm";
import { routes } from "../routes";
import { useNavigate } from "react-router-dom";
import { AuthorityDTO } from "../models/Authority";

const CreateUserPage: React.FC = () => {
  const { showLoader, hideLoader } = useLoaderProvider();
  const navigate = useNavigate();

  const onFinish = async (values: UserDoctorDto) => {
    showLoader("Creazione utente in corso...");
    try {
      values.authorities = [
        { name: values.authorities } as unknown as AuthorityDTO,
      ];
      await userKcService.createUser(values);
      notification.success({
        message: "Creazione utente avvenuta con successo",
        description: "Riceverai una mail quando il tuo account sarà attivato.",
      });

      navigate(routes.USER_REPORT);
    } catch (error) {
      notification.error({
        message: "Errore durante la creazione dell'utente",
      });
    } finally {
      hideLoader();
    }
  };

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "24px" }}>
      <UserProfileForm onFinish={onFinish} showRoleSelect isCreate />
    </div>
  );
};

export default CreateUserPage;
